const workflowEmailTemplate = {
  id: null,
  name: null,
  clientId: null,
  clientName: null,
  subjectLine: null,
  bodyHtml: null,
  recipientSourceId: null,
  recipientSourceName: null,
  customRecipients: null,
  additionalRecipients: null,
  reviewerEmails: null,
  isActive: true,
  attachments: [],
  createdBy: null,
  updatedBy: null,
  createdAt: null,
  updatedAt: null,
  deactivatedByUserId: null,
  deactivatedAt: null
}

export default () => Object.assign({}, workflowEmailTemplate, { attachments: [] })
